import { Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { StyledLoginFormContainer } from "../styled-login-form-container";
import { PacknetLogo } from "../packnet-logo";

export const InvalidAccessView = () => {
	return (
		<StyledLoginFormContainer maxWidth="sm" data-testid="invalid-access">
			<Grid container direction="column" gap={6}>
				<PacknetLogo />

				<Grid container direction="column" gap={2}>
					<Typography fontWeight="bold">
						<FormattedMessage id="invalid-access.header" defaultMessage="Insufficient Access" />
					</Typography>
					<Typography>
						<FormattedMessage
							id="invalid-access.subheader"
							defaultMessage="We're sorry, but you do not have sufficient access to view this page. Please contact your system administrator or Packsize representative."
						/>
					</Typography>
				</Grid>
			</Grid>
		</StyledLoginFormContainer>
	);
};
